

import Cookies from 'js-cookie'

const TokenKey = 'Token'
export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token)
}

export function setCToken (token) {
  let key = process.env.VUE_APP_CTOKEN
  let domain = document.domain;
  domain = domain.split('.').splice(1).join('.');
  Cookies.set(key, token, { path: '/', domain: `.${domain}` });
}

export function removeCToken () {
  let key = process.env.VUE_APP_CTOKEN
  return Cookies.remove(key)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}
